import React, { useState } from 'react';
import moment from 'moment';
import {
  Box
} from '@material-ui/core';

import 'react-dates/initialize';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

const SalesRangePicker = (props) => {

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [focusedInput, setFocusedInput] = useState();
  
  const onChange = ({startDate, endDate}) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if(startDate && endDate){
      props.showSalesTable({
        startDate: new Date(startDate._d.setHours(0,0,0,0)),
        endDate: new Date(endDate._d.setHours(0,0,0,0))
      })
    }
  };

  return(
    <Box>
      <p>Select the Range of Dates to Display Sales</p>
      <DateRangePicker
        startDate={startDate} // momentPropTypes.momentObj or null,
        startDateId="123456" // PropTypes.string.isRequired,
        endDate={endDate} // momentPropTypes.momentObj or null,
        endDateId="567890" // PropTypes.string.isRequired,
        displayFormat="DD/MM/YYYY"
        onDatesChange={onChange} // PropTypes.func.isRequired,
        focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
        isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
      />
    </Box>
  )
};

export default SalesRangePicker;